import React, { useState } from 'react'
import { colors } from '@giphy/react-giphy-brand'
import styled, { css } from 'styled-components'
import SharedCopyableInput from 'shared/components/inputs/copyable'
import { SOCIAL_TYPES } from 'shared/util/gif-social'
import { mobile } from 'shared/util/media-query'

const Container = styled.div`
    background: ${colors.giphyDarkestGrey};
    height: footerHeight;
    overflow: hidden;
    height: 36px;
    ${mobile.css`
        height: 50px;
    `}
`

const ButtonContainer = styled.div<{ hide?: boolean }>`
    box-sizing: border-box;
    display: flex;
    position: relative;
    justify-content: center;
    transition: opacity 0.3s ease-out, margin-top 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);
    height: 36px;

    ${mobile.css`
        height: 50px;
    `}

    ${props =>
        props.hide &&
        css`
            opacity: 0;
            margin-top: -36px;

            ${mobile.css`
                margin-top: -50px;
            `}
        `}
`

const SocialIcon = styled.a<{ isEmbed?: boolean }>`
    color: ${colors.giphyWhite};
    width: 100%;
    font-size: 14px;
    line-height: 42px;
    display: flex;
    align-items: center;
    justify-content: center;

    &:active {
        background: rgba(0, 0, 0, 0.1);
    }

    &:hover {
        color: giphyWhite;
    }

    ${mobile.css`
        font-size: 18px;
        line-height: 52px;
    `}

    ${props =>
        props.isEmbed &&
        css`
            &:before {
                font-size: 26px;
                line-height: 38px;
            }
        `}
`

const CopyLink = styled.div<{ hide?: boolean }>`
    display: flex;
    height: footerHeight;
    transition: opacity 0.3s ease-out;
    height: 36px;
    opacity: ${props => (props.hide ? 0 : 1)};
    ${mobile.css`
        height: 50px;
    `}
`

const CopyableInput = styled(SharedCopyableInput)<{ isMobile?: boolean }>`
    ${props =>
        props.isMobile &&
        css`
            width: 100%;
            flex-grow: 1;
            color: ${colors.giphyGrey};
            -webkit-appearance: none;
            border: 0;
            flex-shrink: 1;
            outline: none;
            padding: 5px;
            height: 36px;
            padding: 5px 10px;

            ${mobile.css`
                padding: 5px;
            `}
        `}
`

const CloseLink = styled.i`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    background-color: ${colors.giphyRed};
    width: 36px;

    ${mobile.css`
        line-height: 52px;
        width: 50px;
        height: 50px;
    `}
`

// This is required because the global-message-manager is not with typescript
const globalAny: any = global

const Link = ({ url, hide, onClose }) => {
    return (
        <CopyLink hide={hide}>
            <CopyableInput
                value={url}
                className=""
                onCopy={() => globalAny.showSuccess && globalAny.showSuccess('Copied to clipboard!')}
            />
            <CloseLink className="ss-delete button" onClick={onClose} />
        </CopyLink>
    )
}

const Footer = ({
    gif,
    mobileFb = '',
    items = [SOCIAL_TYPES.FACEBOOK, SOCIAL_TYPES.TWITTER, SOCIAL_TYPES.PINTEREST, SOCIAL_TYPES.LINK],
    getSocialUrls,
    getEmbed,
    socialClick,
    className = '',
}) => {
    const [inputContent, setInputContent] = useState('')
    const socialUrls = getSocialUrls(gif)
    const { twitter, pinterest, facebook } = socialUrls

    const buttonProps = {
        facebook: { onClick: () => socialClick(facebook, mobileFb, gif) },
        twitter: { onClick: () => socialClick(twitter) },
        pinterest: { onClick: () => socialClick(pinterest) },
        link: { onClick: () => setInputContent(gif.url) },
        embed: { onClick: () => setInputContent(getEmbed(gif)) },
    }

    return (
        <Container className={className}>
            <ButtonContainer hide={!!inputContent}>
                {items.map((socialItem, index) => {
                    const { onClick } = buttonProps[socialItem]
                    return (
                        <SocialIcon
                            isEmbed={socialItem === 'embed'}
                            className={`${['facebook', 'twitter', 'pinterest', 'instagram', 'tumblr'].includes(
                                socialItem
                            ) && 'ss-social'} 
                            ${socialItem === 'embed' ? 'giphyicon' : 'ss'}-${socialItem} `}
                            onClick={onClick}
                            target="_blank"
                            key={index}
                        />
                    )
                })}
            </ButtonContainer>
            <Link url={inputContent} hide={!inputContent} onClose={() => setInputContent('')} />
        </Container>
    )
}

export default Footer
